import NaoConformidade from './NaoConformidade';

export default NaoConformidade;